/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable  jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-autofocus */

import React, { useState } from "react";
import Drawer from "rc-drawer";
import { getItemDescription } from "../../../../../../utils/dataRetrieval";
import { MOBILE_BREAKPOINT } from "../../../../../../const/layout";
import TeacherInfoPanelContent from "../TeacherInfoPanelContent/TeacherInfoPanelContent";
import { useResourceSeriesMOA } from "../../../../../../components/Player/ResourceSeries/utils/moaResourceSeriesUtils";
import { InfoPanelProps } from "../../../../../../interfaces/Player";

import "rc-drawer/assets/index.css";
import "rc-collapse/assets/index.css";
import "./TeacherPlayerInfoPanel.scss";
import arrow from "./arrow.svg";

const TeacherPlayerInfoPanel = ({ getContainer }: InfoPanelProps) => {
    const [open, setOpen] = useState<boolean>(
        window.innerWidth > MOBILE_BREAKPOINT
    );

    const { objective, activity } = useResourceSeriesMOA();
    if (!objective || !activity) return null;
    const objectiveDescription = getItemDescription(objective, "teacher");
    const activityDescription = getItemDescription(activity, "teacher");

    if (
        !objectiveDescription &&
        !objective.targetedDifficulties?.$html &&
        !activityDescription
    )
        return null;

    return (
        <Drawer
            className="teacher-player-info-panel"
            rootClassName="teacher-info__drawer__container"
            open={open}
            placement="left"
            width={380}
            getContainer={getContainer}
            mask={false}
            motion={{
                motionAppear: true,
                motionName: "teacher-info__drawer--motion",
            }}
            autoFocus={false}
        >
            <div className="drawer-handle" onClick={() => setOpen(!open)}>
                <DrawerExpandIcon open={open} />
            </div>
            <TeacherInfoPanelContent />
            <div
                aria-hidden="true"
                className="teacher-info-drawer__hidden-handler"
                onClick={() => setOpen(!open)}
            />
        </Drawer>
    );
};

const DrawerExpandIcon = (props: any) => {
    return (
        <img
            className={"custom-drawer-handle-icon"}
            style={{
                transition: "transform .2s",
                transform: `rotate(${props.open ? 90 : -90}deg)`,
            }}
            src={arrow}
            alt="collapse"
        />
    );
};

export default TeacherPlayerInfoPanel;
